import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { StudentService } from 'src/app/user-management/_services/student.service';
import { environment } from 'src/environments/environment';
import { AudioRecordingService } from '../_services/audio-recording.service';
import { NgxWavesurferService } from 'ngx-wavesurfer';
import { NgxWavesurferRxjsService, WaveSurferRxJSEventObservables } from 'ngx-wavesurfer-rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';


declare var $: any;

@Component({
  selector: 'app-record-modal',
  templateUrl: './record-modal.component.html',
  styleUrls: ['./record-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class RecordModalComponent implements OnInit {
  @Input() image;
  @Input() name;
  @Input() id;
  @Input() isRecorded;
  @Output() navigate = new EventEmitter();
  waveSurfer: any = null;
  waveSurferRxJS: WaveSurferRxJSEventObservables = {};
  isPlayingFlag: boolean = false;
  subscription: Subscription 
  studentImage;
  isPlaying = false;
  displayControls = true;
  isAudioRecording = false;
  isUploadStarted = false;
  isUploadFailed = false;
  errorMsg;
  audioRecordedTime;
  audioBlobUrl;
  audioBlob;
  audioName;
  audioStream;
  audioConf = { audio: true }
  constructor(
    private studentService: StudentService,
    private ref: ChangeDetectorRef,
    private audioRecordingService: AudioRecordingService,
    private sanitizer: DomSanitizer,
    public waveSurferService: NgxWavesurferService,
    public waveSurferRxJSService: NgxWavesurferRxjsService,
    private translate: TranslateService,
  ) {
    this.audioRecordingService.recordingFailed().subscribe(() => {
      this.isAudioRecording = false;
      this.ref.detectChanges();
    });

    this.audioRecordingService.getRecordedTime().subscribe((time) => {
      this.audioRecordedTime = time;
      this.ref.detectChanges();
    });
    this.subscription= this.audioRecordingService.getRecordedBlob().subscribe((data) => {
      this.audioBlob = data.blob;
      this.audioName = data.title;
      // this.audioBlobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));
      this.audioBlobUrl = URL.createObjectURL(this.audioBlob);
      setTimeout(() => {
        this.waveSurfer = this.waveSurferService.create({
          container: '#waveform',
          height: 64,
          barWidth: .5,
          barHeight: 10,
          progressColor: '#4ca4f8',
          cursorColor: '#1564a9',
          cursorWidth: 2,
          // rtl:isLng,
        });
        this.waveSurfer.load(
          // 'https://www.kennethcaple.com/api/mp3/richinlovemutedguitarechoing.mp3'
          this.audioBlobUrl

        );
      }, 50);

      this.ref.detectChanges();
    });
  }

  ngOnInit(): void {
    this.audioBlobUrl = null;
  }

  getImage() {
    return environment.img_url + this.image
  }



  startAudioRecording() {
    if (!this.isAudioRecording) {
      this.isAudioRecording = true;
      this.audioRecordingService.startRecording();
    }
  }

  abortAudioRecording() {
    if (this.isAudioRecording) {
      this.isAudioRecording = false;
      this.audioRecordingService.abortRecording();
    }
  }

  stopAudioRecording() {
    if (this.isAudioRecording) {
      this.audioRecordingService.stopRecording();
      this.isAudioRecording = false;
    }
  }

  clearAudioRecordedData() {
    this.audioBlobUrl = null;
   // to stop the wave sound in case of clearing the recorded wavesound while sound is playing 
    if (this.waveSurferService.WaveSurfer.isPlaying()) {
      this.waveSurferService.WaveSurfer.stop();
    }
  }

  downloadAudioRecordedData() {
    this.isUploadStarted = true;
    this._downloadFile(this.audioBlob, 'audio/mp3', this.audioName);
  }

  ngOnDestroy(): void {
    this.audioBlob=null;
    /* unsbscribe to the observale that returns the blob
     to handle a bug that dublicates the blob in case of connection lost 
     and navigate to other modules and back to voice module 
     when the connection is back*/
    this.subscription.unsubscribe();
    this.abortAudioRecording();
  }

  _downloadFile(data: any, type: string, filename: string): any {
    const formData = new FormData();
    const blob = new Blob([data], { type: type });
    formData.append('audio_file', blob);
    formData.append('upload_type', 'recorded');
    this.studentService.uploadStudentAudio(this.id, formData).subscribe(res => {
    },
      (err => {
        switch (err.status ) {
          case 422:
            this.errorMsg = this.translate.instant('names-sounds.record-modal.error-msg-422')
            break;
          case 413:
            this.errorMsg = this.translate.instant('names-sounds.record-modal.error-msg-413')
            break;
          default:
          this.errorMsg=this.translate.instant('names-sounds.record-modal.error-msg-500')
        }
        this.isUploadFailed = true;

      }), () => {
        this.audioBlobUrl = null;
        this.isAudioRecording = false;
        this.navigate.emit('reload');
       // to stop the wave sound in case of uploading the record is done while sound is playing 
        if (this.waveSurferService.WaveSurfer.isPlaying()) {
          this.waveSurferService.WaveSurfer.stop();
        }
        this.isUploadStarted = false;
      });
    // to download audio file on your local machine
    // const url = window.URL.createObjectURL(blob);
    // const anchor = document.createElement('a');
    // anchor.download = filename;
    // anchor.href = url;
    // document.body.appendChild(anchor);
    // anchor.click();
    // document.body.removeChild(anchor);
  }

  playPause() {
    this.waveSurferService.WaveSurfer.playPause();
    this.checkPlaying();
  }

  checkPlaying() {
    if (this.waveSurferService.WaveSurfer.isPlaying()) {
      this.isPlayingFlag = true;
    }
    else {
      this.isPlayingFlag = false;
    }
    setTimeout(() => {
      this.checkPlaying();

    }, 500);
  }

  backBtnClicked() {
    this.navigate.emit('back');
  }
  nextBtnClicked() {
    this.navigate.emit('next');
  }

  closeModal() {
    this.errorMsg='';
    this.isUploadFailed = false;
    this.audioBlobUrl = null;
    this.isAudioRecording = false;
    this.isUploadStarted = false;
    // abort recording on modal close to reset the record and timer 
    this.audioRecordingService.abortRecording();
    // to stop the wave sound in case of closing the modal while sound is playing 
    if (this.waveSurferService.WaveSurfer.isPlaying()) {
      this.waveSurferService.WaveSurfer.stop();
    }
    $('#recordModal').modal("hide");
    // this.navigate.emit('reload');
  }
}
